import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import VMSecureStateConfigListing from './VMSecureStateConfigListing'
import VMSecureStateCredentialForm from './VMSecureStateCredentialForm'

export default function VMSecureStatePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={VMSecureStateCredentialForm}
            PullConfigListingView={VMSecureStateConfigListing}
        />
    )
}